import { render } from "./PriorityRow.vue?vue&type=template&id=28909a16&scoped=true"
import script from "./PriorityRow.vue?vue&type=script&lang=js"
export * from "./PriorityRow.vue?vue&type=script&lang=js"

import "./PriorityRow.vue?vue&type=style&index=0&id=28909a16&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28909a16"]])

export default __exports__